<template>
    <div class="activity">
        <ul class="lists">
            <li @click="getActivityInfo(0,'1')" :class='{ lists_active:activity_index === 0} '>{{$t('activity[0]')}}
            </li>
            <li @click="getActivityInfo(1,'1')" :class='{ lists_active:activity_index === 1}'>{{$t('activity[1]')}}</li>
            <li @click="ticketGrabbing()" :class='{ lists_active:activity_index === 2} '>{{$t('activity[2]')}}</li>
        </ul>
        <div style='width: 100%;text-align: center;margin: 120px 0 20px 0;' v-if="isEmptyData"><img
                src='../../assets/images/no_page.png' alt='' width="160"></div>
        <div class="activity_content" v-else ref="lists">
            <div v-if="activity_index===0&&activityLists.length >0||activity_index===1 &&activityLists.length >0">
                <NearActivity v-for="(a,i) in activityLists"
                              :nearLists="a" :key="i"></NearActivity>
                <div v-html="pagination" class="paging_numbers" ref="pagination"></div>
            </div>
            <div v-else-if="activity_index === 2 && grabbingLists.length >0">
                <grabbing v-for="(n,o) in grabbingLists" :grabbingItem="n" :key="o"></grabbing>
            </div>
        </div>

    </div>
</template>

<script>
import NearActivity from "../../components/activitys/nearActivity";
import grabbing from "../../components/activitys/grabbing";

export default {
  name: "activity",
  components: {
    NearActivity,
    grabbing
  },
  inject: ["reload", "showMsg"],
  data: function() {
    return {
      // navLists: ['近期活动', '特别优惠', '抢票活动'],
      activity_index: 0,
      isEmptyData: false,
      activityLists: [],
      grabbingLists: [],
      pagination: ""
    };
  },
  created: function() {
    this.getActivityInfo(0, "1");
    this.$store.commit("set_current", 3);
    this.$store.commit("set_title", "nav.activity");
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const _a = this.$refs.lists.children;
        const _aLen = _a[0].children.length;
        if (_aLen > 5) {
          this.GetDom();
        }
      }, 1000);
    });
  },
  methods: {
    getActivityInfo(i, p) {
      this.activity_index = i;
      let n = parseInt(i) + parseInt("1");
      this.$http({
        method: "post",
        url: this.weburl + "home/information/informationList?p=" + p,
        dataType: "json",
        data: {
          cid: n,
          status: 0,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            if (!res.data.result) {
              this.isEmptyData = true;
            } else {
              this.isEmptyData = false;
              this.activityLists = res.data.result.param;
              this.pagination = res.data.result.show;
              setTimeout(() => {
                const _a = this.$refs.lists.children;
                const _aLen = _a[0].children.length;
                if (_aLen > 5) {
                  this.GetDom();
                }
              }, 1000);
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    ticketGrabbing() {
      this.activity_index = 2;
      this.$http({
        method: "post",
        url: this.weburl + "home/Activity/flashSaleList",
        dataType: "json",
        data: {
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.result) {
              this.isEmptyData = true;
            } else {
              this.isEmptyData = false;
              this.grabbingLists = res.data.result;
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    GetDom() {
      var DOM = this.$refs.pagination;
      var a_dom = DOM.getElementsByTagName("a");
      var that = this;
      for (var i = 0; i < a_dom.length; i++) {
        a_dom[i].onclick = function() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          that.getActivityInfo(that.activity_index, this.dataset.p);
        };
      }
    }
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/nav";

.activity {
  width: @width;
  .media;
  background: @bg;
  padding-bottom: 1px;
  /* .activity_lists {
             background: @font-primary;
             display: flex;
             font-size:@font - .1;
             height:48px ;
             line-height: $height;
             color:@word;
             li {
                 padding:0 20px ;
                 &.activity_active {
                     position: relative;
                     color:@brick_red;
                     &:after {
                         background: @brick_red;
                         .border-radius(5px);
                         content: '';
                         width: 30%;
                         height: 4px;
                         border-radius: 5px;
                         bottom: 8px;
                         left: 35%;
                         animation: move 500ms alternate;
                     }
                 }
             }

         }*/
  .activity_content {
    .box-sizing;
    width: @width;
    padding: 0 20px;
    @media (min-width: 768px) {
      padding: 0 30px;
    }
  }
}

.lists {
  margin-bottom: 20px;
}

.lists_active {
  color: @brick_red;
  &:after {
    background: @brick_red;
  }
}
</style>
<style>
@import "../../assets/css/pagination.css";

/* .paging_numbers  ul{
         display: flex;
         justify-content: center;
         align-items: center;
     }
     .paging_numbers  ul  li {
         margin: 0 10px 10px  0;
         padding: 4px  10px;
         border-radius: 5px;
         border: 1px solid #ccc;
         background: #fff;
     }
     .paging_numbers  ul  li a{
         display: block;
         width: 100%;
     }
     .paging_numbers  ul  li.active {
         background: #7e272f;

     }
     .paging_numbers  ul  li.active a {
         color:#fff;
     }
   @media (min-width: 768px) and (orientation: portrait){
       .paging_numbers  ul  li {
           margin: 0 10px 10px  0;
           padding: 6px  12px;
           border-radius: 5px;
           border: 1px solid #ccc;
           background: #fff;
       }
   }*/
</style>
